import api from './api'
class HomePageService {
  static getHomePage() {
    return api.call('get', '/pages/home').then(api.getData)
  }
  static getSuggestions() {
    return api.call('get', '/pages/home/suggestions').then(api.getData)
  }
  static getBrands() {
    return api.call('get', '/brands/homepage').then(api.getData)
  }
}

export default HomePageService
